export const fields = [
    {
        label: "",
        key: "type_icon",
    },
    {
        label: "&check;",
        key: "selected",
        sortable: false,
    },
    {
        label: "Name",
        key: "name",
        sortable: true,
    },
    {
        label: "Description",
        key: "message",
        sortable: true,
    },
    {
        label: "Type",
        key: "type",
        sortable: true,
    },
    {
        label: "Size",
        key: "raw_size",
        sortable: true,
    },
    {
        label: "Updated",
        key: "update_time",
        sortable: true,
    },
    {
        label: "State",
        key: "state",
        sortable: false,
    },
    {
        label: "",
        key: "is_unrestricted",
        sortable: false,
    },
    {
        label: "",
        key: "buttons",
        sortable: false,
    },
];
